module.exports = __webpack_public_path__ + "static/media/sneha_venk.f913e127.png";